var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.items),function(item){return _c('v-btn',_vm._b({key:item.href,staticClass:"ma-1",attrs:{"small":"","fab":"","color":"secondary","href":item.href,"target":"_blank"}},'v-btn',_vm.btnProps,false),[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }